import BaseApi from "../BaseApi";

export default class Locales extends BaseApi {
    construct() {}

    static getApiUrl() {
        return BaseApi.getApiVersionBasePath("v1") + "locales/";
    }

    static async all() {
        return this.get(this.getApiUrl());
    }
}
